import actions from '../actions';
import { put, takeEvery } from 'redux-saga/effects';
import { createTheme } from '@mui/material/styles';

export function* themesFlow() {
  yield takeEvery(actions.app.themes.createTheme, function* takeCreateTheme({
    payload: { colors }
  }) {
    try {
      const { light, main, dark, contrastText } = colors; 
      const newTheme = createTheme({
        palette: {
          primary: {
            light,
            main,
            dark,
            contrastText,
          },
          common: {
            white: '#fff'
          }
        },
      });
      yield put(actions.app.themes.createThemeSuccess(newTheme))
    } catch(e) {
      yield put(actions.app.themes.createThemeFailure(e))
    }
  })

  yield takeEvery(actions.app.appState.setAccountDetails, function* takeSetAccountDetails({
    payload: { accountDetails }
  }) {
    try {
      // Update theme based on account details
      yield put(actions.app.themes.updateThemeFromAccount(accountDetails));
    } catch(e) {
      console.error('Error updating theme from account details:', e);
    }
  })
}